import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import { Group } from './interface/Group'

interface PropsListDatabase {
    group: Group[]
}
export default function ListDatabase({ group = [] }: PropsListDatabase) {
    return (
        <ListDatabaseContainer>
            <div className="list-header-div">
                <div className="list-header-item">{i18n('Databases')}</div>
                <div className="list-header-item">{i18n('Tab (index or ID)')}</div>
                <div className="list-header-item">{i18n('Date reference')}</div>
            </div>

            {group.map(({ databaseName, matchTabName, refDate }) => {
                return (
                    <div className="list-body-div">
                        <div className="list-body-div-item">{databaseName}</div>
                        <div className="list-body-div-item">{matchTabName}</div>
                        <div className="list-body-div-item">{refDate}</div>
                    </div>
                )
            })}
        </ListDatabaseContainer>
    )
}

const ListDatabaseContainer = styled.div`
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 16px;
    width: 100%;
    font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
    border: 1px solid var(--gray-400);
    border-radius: 5px;

    .list-header-div {
        height: 28px;
        background-color: var(--gray-100);
        display: grid;
        grid-template-columns: 40% 30% 30%;
        color: var(--gray-700);
        align-items: center;
        font-size: 11px;
        font-weight: 600;
        line-height: 12px;
    }

    .list-header-item {
        color: var(--gray-800);
        padding-left: 20px;
        display: grid;
        align-items: center;
        justify-content: left;
        text-align: left;
    }

    .list-body-div {
        display: grid;
        grid-template-columns: 40% 30% 30%;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
    }

    .list-body-div-item {
        padding-left: 20px;
        height: 32px;
        display: grid;
        align-items: center;
        justify-content: left;
        text-align: left;
        color: var(--gray-800);
        border-top: 1px solid var(--gray-400);
    }
`
